import fetch         from 'isomorphic-fetch';
import ApiRequest    from './../classes/ApiRequest';
import parseDomain   from 'parse-domain';
import { getConfig } from './../classes/Config';

export const REQUEST_AUTH  = 'REQUEST_AUTH';
export const RECEIVE_AUTH  = 'RECEIVE_AUTH';

const receiveAuth = (data) =>
{
    return (dispatch) =>
    {
        dispatch({
            type : RECEIVE_AUTH,
            token: data.token
        });
    }
};

const fetchAuth = () =>
{
    return (dispatch) =>
    {
        let instance;
        let domain = parseDomain(window.location.host);
        if (domain === null || '' === domain.subdomain || 'www' === domain.subdomain)
        {
            instance = getConfig('MASTER_INSTANCE');
        }
        else
        {
            instance = domain.subdomain;
        }

        let api         = new ApiRequest({  body: { instance: instance } });
        let authRequest = api.buildAuthRequest();

        dispatch({ type: REQUEST_AUTH });

        return fetch(authRequest)
            .then((response) =>
            {
                return response.json()
            })
            .then((json) =>
            {
                dispatch(receiveAuth(json.data))
            })
            .catch(() =>
            {
                window.location.replace(getConfig('REDIRECT_AUTH_ERROR'));
            });
    }
};

const shouldFetchAuth = (state) =>
{
    const data = state.auth;
    if (!data.fetched)
    {
        return true
    }
    else if (data.fetching)
    {
        return false
    }
};

export const fetchAuthIfNeeded = () =>
{
    return (dispatch, getState) =>
    {
        if (shouldFetchAuth(getState()))
        {
            return dispatch(fetchAuth())
        }
        else
        {
            return Promise.resolve()
        }
    }
};


// WEBPACK FOOTER //
// ./src/actions/AuthAction.js